export const DATA_REQUEST = "DATA_REQUEST"
export const DATA_SUCESS = "DATA_SUCESS"
export const DATA_FAILURE  = "DATA_FAILURE"

export const POST_REQUEST = "POST_REQUEST"
export const POST_SUCESS = "POST_SUCESS"
export const POST_FAILURE  = "POST_FAILURE"